/**
 * Shared coordinate formatting used by multiple features (import, media-units).
 *
 * Rules:
 * - Each formatter must be defined in exactly one canonical location.
 * - Features MUST import from here instead of redefining the same formatting.
 */

/**
 * Fixed number of decimal places used when displaying a coordinate value.
 * Display-only: DB storage, contracts, and map `href` links keep full precision.
 */
export const COORDINATE_DISPLAY_DECIMALS = 6;

/**
 * Formats a single coordinate axis for display with a uniform, fixed number of
 * decimal places (trailing zeros preserved). Returns '—' for null/undefined.
 * The output remains a valid numeric string that parses back via parseFloat.
 */
export function formatCoordinate(value: number | null | undefined): string {
  if (value == null) return '\u2014';
  return value.toFixed(COORDINATE_DISPLAY_DECIMALS);
}
